/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "./style.css";

import amc_logo from "../../../../../assets/imgs/amc-domestico/logo_AMC.png";
import axios from "axios";
import { hiddenMedalliaButton } from "../../../light-load/components/hidemedallia";

const HeavyLoadReceptionSecunday = () => {
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [turns, setTurns] = useState([]);

  useEffect(() => {
    const cleanMedallia = hiddenMedalliaButton();
    return cleanMedallia;
  }, []);

  const fetchAllShifts = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/supervisor/dashboard`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );

      if (res.data.code !== 1) return;

      const {
        turn_in_progress,
        turns_next,
        turns_in_progress: historical_turns,
        turns_without_quantity_id,
      } = res.data.data;

      let currentTurn = [];
      let nextTurns = [];
      let lastTurns = [];
      let weigherTurns = [];

      // 1. Procesar Turno Actual (Azul)
      if (turn_in_progress) {
        currentTurn = [{ ...turn_in_progress, type: "current" }];
      }

      // 2. Procesar Datos de Endpoints (Manteniendo tu inversión de nombres actual)
      const turnsInLastRes = historical_turns || [];

      // Lista para la parte blanca (next)
      nextTurns = turnsInLastRes.map((turn) => ({ ...turn, type: "next" }));

      // Lista para la parte gris (last)
      lastTurns = (turns_next || []).map((turn) => ({
        ...turn,
        type: "last",
      }));

      // Lista para báscula
      weigherTurns = (turns_without_quantity_id || []).map((turn) => ({
        ...turn,
        type: "weigher",
      }));

      // Ordenar por fecha
      nextTurns.sort((a, b) => new Date(a.date) - new Date(b.date));
      lastTurns.sort((a, b) => new Date(a.date) - new Date(b.date));
      weigherTurns.sort((a, b) => new Date(a.date) - new Date(b.date));

      // Seleccionar hasta 3 de 'next'
      const selectedNext = nextTurns.slice(0, 3);

      // Usar el turno actual si existe
      const selectedCurrent = currentTurn.find(turn => turn.isTopUser) || (currentTurn.length > 0 ? currentTurn[0] : null);

      // 4. LÓGICA DE FILTRADO (ELIMINAR DUPLICADOS EN LA PARTE GRIS)
      // Creamos un Set con los turnos que YA están arriba
      const turnosEnPantallaSuperior = new Set();
      if (selectedCurrent) turnosEnPantallaSuperior.add(String(selectedCurrent.turn_number));
      selectedNext.forEach(t => turnosEnPantallaSuperior.add(String(t.turn_number)));

      // Filtramos la lista gris para que no contenga nada de lo de arriba
      const lastTurnsSinDuplicados = lastTurns.filter( (turn) => turn.isTopUser || !turnosEnPantallaSuperior.has(String(turn.turn_number)));
      
      // Filtramos también la báscula por si acaso
      const weigherTurnsSinDuplicados = weigherTurns.filter( (turn) => turn.isTopUser || !turnosEnPantallaSuperior.has(String(turn.turn_number)));

      // Calcular cuántos elementos ya tenemos
      const countNext = selectedNext.length;
      const countCurrent = selectedCurrent ? 1 : 0;
      const usedSlots = countNext + countCurrent;

      // Calcular espacios restantes
      const remainingSlots = 10 - usedSlots;

       // Seleccionamos solo los que caben de las listas filtradas
       let numLast = Math.min(remainingSlots, lastTurnsSinDuplicados.length);
       const selectedLast = lastTurnsSinDuplicados.slice(0, numLast);
 
       let numWeigher = Math.max(0, remainingSlots - selectedLast.length);
       const selectedWeigher = weigherTurnsSinDuplicados.slice(0, numWeigher)

      const orderedShifts = [
        ...selectedNext, // siempre arriba
        ...(selectedCurrent ? [selectedCurrent] : []), // luego el actual
        ...selectedLast, // prioridad
        ...selectedWeigher,
      ];

      setTurns((prevTurns) => {
        if (arraysAreEqual(prevTurns, orderedShifts)) {
          return prevTurns; 
        }
        return orderedShifts;
      });
    } catch (error) {
      console.error("Error fetching shifts:", error);
    }
  };

  function formatHour(dateString) {
    const [datePart, timePart] = dateString.split(" ");
    const [day, month, year] = datePart.split("/");

    const isoFormat = `${year}-${month}-${day}T${timePart}`;

    const date = new Date(isoFormat);
    if (isNaN(date.getTime())) {
      return "Fecha inválida";
    }

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const arraysAreEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;

    // Comparamos convirtiendo a JSON para validar el contenido real
    // en lugar de comparar el espacio en memoria del objeto
    return JSON.stringify(arr1) === JSON.stringify(arr2);
  };

  useEffect(() => {
    fetchAllShifts();

    const interval = setInterval(fetchAllShifts, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    function getFormattedDate() {
      const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];

      const now = new Date();
      const dayName = days[now.getDay()];
      const day = now.getDate();
      const monthName = months[now.getMonth()];
      const year = now.getFullYear();

      return `${dayName}, ${day} de ${monthName} ${year}`;
    }

    function getFormattedTime() {
      const now = new Date();
      let hours = now.getHours(); // Mantén las horas tal cual están en formato de 24 horas
      const minutes = now.getMinutes().toString().padStart(2, "0");

      // Devuelve el tiempo en formato 24 horas
      return `${hours}:${minutes}`;
    }

    const interval = setInterval(() => {
      setCurrentDate(getFormattedDate());
      setCurrentTime(getFormattedTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="reception-container">
        <div className="reception-banner">
          <div className="banner-header">
            <div className="header-image">
              <img src={amc_logo} alt="amc-logo" />
            </div>
            <div className="header-hours">
              <span>{currentDate}</span>
              <span>{currentTime}</span>
            </div>
          </div>
          <div className="banner-body">
            <video
              src="https://dyn-pwc-ac.amlab7.com/pantalla-turnos-video-v2.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="banner-video"
            />
          </div>
        </div>
        <div className="reception-turns">
          <div className="turns-body">
            <div className="next-shifts">
              <div className="tabla">
                <div className="tabla-header">
                  <div className="header-cell">Turno</div>
                  <div className="header-cell">Mostrador</div>
                  <div className="header-cell">Inicio</div>
                  <div className="header-cell">Pesaje</div>
                </div>
                {turns.length === 0 ? (
                  <p
                    style={{
                      marginTop: "10vh",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    No hay turnos por mostrar
                  </p>
                ) : (
                  <>
                    {turns.slice(0, 11).map((item, index) => {
                      const checkoutName = item.counter_checkout_name
                        ? item.counter_checkout_name.replace("Mostrador ", "")
                        : "-";

                      return (
                        <div className="tabla-row" key={index}>
                          <div
                            className={`cell ${
                              item.type === "current" ? "current-turn" : ""
                            } ${item.type === "next" ? "next-turn" : ""} ${
                              item.type === "last" ? "last-turn" : ""
                            } ${item.type === "weigher" ? "weigher-turn" : ""}`}
                          >
                            {item.turn_number}
                          </div>
                          <div
                            className={`cell ${
                              item.type === "current" ? "current-turn" : ""
                            } ${item.type === "next" ? "next-turn" : ""} ${
                              item.type === "last" ? "last-turn" : ""
                            } ${item.type === "weigher" ? "weigher-turn" : ""}`}
                          >
                            {checkoutName}
                          </div>
                          <div
                            className={`cell ${
                              item.type === "current" ? "current-turn" : ""
                            } ${item.type === "next" ? "next-turn" : ""} ${
                              item.type === "last" ? "last-turn" : ""
                            } ${item.type === "weigher" ? "weigher-turn" : ""}`}
                          >
                            {formatHour(item.created_at ?? item.date) ===
                            "Fecha inválida"
                              ? "-"
                              : formatHour(item.created_at ?? item.date)}
                          </div>
                          <div
                            className={`cell ${
                              item.type === "current" ? "current-turn" : ""
                            } ${item.type === "next" ? "next-turn" : ""} ${
                              item.type === "last" ? "last-turn" : ""
                            } ${item.type === "weigher" ? "weigher-turn" : ""}`}
                          >
                            {"updated_at" in item
                              ? formatHour(item?.updated_at) ===
                                "Fecha inválida"
                                ? "-"
                                : formatHour(item?.updated_at)
                              : "-"}
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            </div>
            <div className="hl-turns-body-messages">
              <h1>Orden de turno conforme a inspección</h1>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeavyLoadReceptionSecunday;
